import { render, staticRenderFns } from "./DisclosureTemplateForm.vue?vue&type=template&id=57652524&scoped=true"
import script from "./DisclosureTemplateForm.vue?vue&type=script&lang=js"
export * from "./DisclosureTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./DisclosureTemplateForm.vue?vue&type=style&index=0&id=57652524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57652524",
  null
  
)

export default component.exports